<div class="layout-inner">
  <a target="_blank" rel="nofollow" (click)="onLinkClick()" class="logo">
    <img src="assets/img/Logo_part1.svg" alt="logo1" class="logo__el1">
    <img src="assets/img/Logo_part2.svg" alt="logo2" class="logo__el2">
  </a>
  <button
    mat-raised-button color="primary"
    class="main-button mobile-hidden"
    (click)="onStartClick()"
  >{{'app.header.start' | translate}}</button>
</div>
